export default __webpack_public_path__ + "static/5-2-0-0-f4bdc4679664f6d56ad31007c5903e01.jpg";